import { Id } from 'src/types'

export enum BedroomsActionTypes {
  GET_BEDROOMS = '@partnerHotels/GET_BEDROOMS',
  GET_BEDROOMS_FAILURE = '@partnerHotels/GET_BEDROOMS_FAILURE',
  GET_BEDROOMS_SUCCESS = '@partnerHotels/GET_BEDROOMS_SUCCESS',
  SEND_BEDROOMS = '@partnerHotels/SEND_BEDROOMS',
  SEND_BEDROOMS_FAILURE = '@partnerHotels/SEND_BEDROOMS_FAILURE',
  SEND_BEDROOMS_SUCCESS = '@partnerHotels/SEND_BEDROOMS_SUCCESS'
}

export type ResponseDataRequests = {
  partner_hotel_rooms: ResponseDataRequestsItem[]
}

interface AgencyPartnerHotel {
  description: string
}

export interface ResponseDataRequestsItem {
  partner_hotel_room_id: Id
  // partner_id: Id
  category: string
  max_adults: number
  comments: string
  agency_partner_hotel_offers: AgencyPartnerHotel[]
  active: boolean
}

export type ResponseDataRequestTotals = {
  request_totals: {
    total_emissions: number
    total_quotations: number
  }
}

export type BedroomsState = ResponseDataRequestTotals & {
  readonly error: string
  readonly list: ResponseDataRequestsItem[]
  readonly loading: boolean
  readonly sendBedroomsError: string
  readonly sendBedroomsLoading: boolean
  readonly total_results: number
}
